import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ForbiddenSvg from "../../../assets/images/error/light-403.png";

const Error403 = () => {
  const navigate = useNavigate();

  return (
    <div id="layoutError" className="bg-white min-h-screen flex flex-col">
      {/* Content */}
      <div id="layoutError_content" className="flex-grow flex items-center justify-center">
        <main className="w-full">
          <div className="container px-4 mx-auto">
            <div className="flex justify-center">
              <div className="lg:w-2/3 text-center">
                <div className="mt-4">
                  {/* Illustration */}
                  <img
                    className="mx-auto p-4 max-w-2xl"
                    src={ForbiddenSvg}
                    alt="403 Forbidden"
                  />

                  {/* Message */}
                  <p className="lead text-xl text-gray-700 mt-4">
                    You do not have permission to access this page.
                    <br />
                    Please contact your administrator if you need access.
                  </p>

                  {/* Return Link */}
                  <button
                    onClick={() => navigate(-1)}
                    className="inline-flex items-center mt-6 px-4 py-2 rounded-lg text-indigo-600 hover:text-indigo-800 font-medium hover:bg-indigo-50 transition"
                  >
                    <ArrowLeft className="w-5 h-5 mr-2" />
                    Go Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Footer */}
      <div id="layoutError_footer">
        <footer className="footer-admin mt-auto bg-gray-100 py-4 text-gray-600 text-sm">
          <div className="container px-4 mx-auto flex flex-col md:flex-row justify-between items-center">
            <div>Copyright © Sufi Creative Works {new Date().getFullYear()}</div>
            <div className="mt-2 md:mt-0 space-x-4">
              <a href="#">Privacy Policy</a>
              <span>·</span>
              <a href="#">Terms &amp; Conditions</a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Error403;
